import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCertifiedRibbon2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "certified-ribbon-2" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.059,23.105l-6.177-4.492a1.5,1.5,0,0,0-1.764,0L4.941,23.105A.75.75,0,0,1,3.75,22.5V2.25A1.5,1.5,0,0,1,5.25.75h13.5a1.5,1.5,0,0,1,1.5,1.5V22.5A.75.75,0,0,1,19.059,23.105Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.5,7.811,11.03,13.28a.749.749,0,0,1-1.06,0L8.25,11.561"
		})
	]
});
export default SvgCertifiedRibbon2;
